import React, { Component, createRef } from 'react';
import '../adminDash.css';
// import globalVariables from "../global_files/globalVariables";
// import { post, get } from '../global_files/serverRequests';
// import { displayDateTime, isEmpty } from '../global_files/validation';
import Chart from 'react-apexcharts';// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import HomepageProgressbars from '../Global_files/HomepageProgressbars';
import { Link } from 'react-router-dom';
import { get } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import withNavigate from '../../Global_files/WithNavigate'; 
import { Button} from '@mui/material';
import { getFreshToken } from '../../custom_libraries/serverRequests';


class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
          live_devices : 0,
          total_devices : 0,

          live_cameras: 0,

          healthy_view: 0,
          
          currently_recording: 0,

          healthy_hdd: 0,
          total_hdd: 0,

          series: [0, 0],
          totalValue : 0,
          options: {
            chart: {
              height: 350,
              type: 'radialBar',
            },
            plotOptions: {
              radialBar: {
                startAngle: 0,
                endAngle: 360, // Full circle
                hollow: {
                margin: 5,
                size: "50%",
                },
                track: {
                show: true, // Show background track
                strokeWidth: "100%",
                },
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                    show: true, // Show raw values
                  },
                  total: {
                    show: true,
                    // showAlways: true,
                    label: 'Total Cameras',
                    formatter: () => {
                      // Use an arrow function to preserve `this` context
                      return this.state.totalValue;
                    },
                  }
                }
              }
            },
            colors: ['#32cd32', '#FFC300'],
            labels: [ 'Cameras Live', 'Cameras down'],
            tooltip: {
                enabled: true,
                y: {
                  formatter: (value, opts) => {
                    // Use the raw value instead of the percentage
                    const rawValue = this.state.series[opts.seriesIndex];
                    return `${rawValue}`; // Customize tooltip content
                  },
                },
              },

          },        
        };
    }

    componentDidMount() {
    setTimeout(() => {
          this.validateSignedIn();
      }, 0);
      this.getMatrixCount();
    }

    validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);
    
        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
      }
      /** 
   * getMatrixCount() function fetches the count of live, down camera and device , count of currently recording cams, count of healthy hdd  
  **/
  getMatrixCount = async () => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const response = await get(urls.STATUS_MATRIX, headers); // Perform the API call using the constructed URL
        console.log("API Response for getMatrixCount:", response);
      
      if (response!== undefined) {
        this.setState({
          series: [
            response['cameras'].live,
            response['cameras'].down,
          ],
          totalValue: response['cameras'].total,
          live_cameras: response['cameras'].live,

          live_devices : response['devices'].active,
          total_devices : response['devices'].total,

          healthy_view: response['operator_ratings'].healthy,
          total_healthy_view: response['operator_ratings'].total,
          currently_recording: response['currently_recording'],

          healthy_hdd: response['hdds'].healthy,
          total_hdd: response['hdds'].total,
        });
        console.error(" fetching getMatrixCount from API:", this.state.series);
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
    }
  };

  NavigateToDevices = () => {
    this.props.navigate("/showDevices");
  }
  

    render() {
      const{live_devices, total_devices, live_cameras, totalValue, healthy_view, total_healthy_view, currently_recording, healthy_hdd, total_hdd,} = this.state

      // Calculate the percentage of active devices
    const activeDevicePercentage = total_devices > 0 ? Math.round((live_devices / total_devices) * 100) : 0;

    const liveCameraePercentage = totalValue > 0 ? Math.round((live_cameras / totalValue) * 100) : 0;

    const healthyHddPercentage = total_hdd > 0 ? Math.round((healthy_hdd / total_hdd) * 100) : 0;

    const healthyOperatorRating = total_healthy_view > 0 ? Math.round((healthy_view / total_healthy_view) * 100) : 0;


        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="home-container" style={{ display: 'flex', flex: '1', height: '100vh', marginTop:'2%' }}>
                  <div className="side-by-side-container" style={{ flex: '1', paddingTop: '8px' }}>
                      <div id="chart">
                          <div className="elevator-card">
                            <p style={{color:'#3b6d97'}}>Current system's health status :</p>
                            <p style={{fontSize: '14px'}}>The system is healthy</p>
                            {/* <button style={{backgroundColor:'#3b6d97', color:'#fff', borderRadius:'5px', marginLeft:'20%', cursor:'pointer'}}>View current issues</button> */}
                            {/* <button id="home-button" onClick={this.NavigateToDevices}>View Details</button> */}
                            <Button
                              id="rowsPerPageButton"
                              onClick={this.NavigateToDevices}
                              variant="contained"
                              sx={{
                                margin: '0 10px',
                                borderRadius: '8px',
                                padding: '8px 10px',
                                fontSize: '14px',
                                minWidth: '90px',
                                background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                boxShadow: 2,
                                '&:hover': {
                                  background: 'linear-gradient(145deg,rgb(44, 82, 120),rgb(65, 145, 165))',  // Inverted gradient for hover effect
                                },
                                cursor: 'pointer',
                              }}
                            >
                            {"View Details"}
                          </Button>
                          </div><br/>
                          {/* Custom Legend */}
                          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{ width: '20px', height: '15px', backgroundColor: '#32cd32', borderRadius: '3px' }}></div>
                              <span>Cameras Live</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{ width: '20px', height: '15px', backgroundColor: '#FFC300', borderRadius: '3px' }}></div>
                              <span>Cameras Down</span>
                            </div>
                          </div>
                          <Chart options={this.state.options} series={this.state.series} type="radialBar" height={350} width={350} />
                          
                      </div>
                      
                      <div className="progress-container">
                        <h2>System Status</h2>
                        {/* <p style={{fontSize: '14px'}}>Quickly compare the current device status to last week</p> */}
                        {/* <p style={{fontSize: '14.7px'}}><b>Devices Live</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            // style={{ width: '1%', backgroundColor: '#d3d3d3', height: '17px' }} ---original
                            style={{ width: `${activeDevicePercentage}%`, backgroundColor: '#4172a2'}}
                          >
                            {activeDevicePercentage}%
                          </div>
                        </div> */}
                        <p style={{fontSize: '14.7px'}}><b>Cameras Live</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: `${liveCameraePercentage}%`, backgroundColor: '#4172a2'}}
                          >
                            {liveCameraePercentage}%
                          </div>
                        </div>
                       
                        <p style={{fontSize: '14.7px'}}><b>Healthy View</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: `${healthyOperatorRating}%`, backgroundColor: '#4172a2'}}
                          >
                            {healthyOperatorRating}%
                            
                          </div>
                        </div>

                       {/* <p style={{fontSize: '14.7px'}}><b>Currently Recording</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: `${currently_recording}%`, backgroundColor: '#4172a2'}}
                          >
                            {currently_recording}%
                          </div>
                        </div> */}
                        {/* <p style={{fontSize: '14px'}}><b>Retaining enough recordings</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: '60%', backgroundColor: '#b09ee3', height: '17px' }}
                          >
                            60%
                          </div>
                        </div>

                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: '70%', backgroundColor: '#d3d3d3', height: '17px' }}
                          >
                            70%
                          </div>
                        </div> */}
                        <p style={{fontSize: '14.7px'}}><b>Hard drive status healthy</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: `${healthyHddPercentage}%`, backgroundColor: '#4172a2', height: '17px' }}
                          >
                            {healthyHddPercentage}%
                          </div>
                        </div>

                        {/* <p style={{fontSize: '14px'}}><b>No time-drift</b></p>
                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: '60%', backgroundColor: '#b09ee3', height: '17px' }}
                          >
                            60%
                          </div>
                        </div>

                        <div className="progress">
                          <div
                            className="progress-bar striped"
                            style={{ width: '70%', backgroundColor: '#d3d3d3', height: '17px' }}
                          >
                            70%
                          </div>
                        </div> */}
                      </div>
                  </div>
                </div>
            </div>
        );
    }

}
export default withNavigate(Home);